import api from '../..'

const requests = {
    fetchParentData: async () => {
        var parentData = await api.get('/maarima/ParentData/parent-data')
        return parentData.data
    }
}

export default requests
